import React from 'react';
import Immutable from 'immutable';
import {
	styled,
	DateUtils,
} from 'ps-gui';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';
const EMPTY_LIST = Immutable.List([]);

export default class RolesTab extends React.PureComponent {
	render() {
		const {parties, toggleAltNamesExpanded} = this.props;

		return <Roles>
			{parties.map((party, index) => {
				const altNames = party.get('altNames');
				const dateOfBirth = party.get('dateOfBirth');
				return (
					<Role key={index}>
						<div className="header">
							<span className="name">
								{party.get('name')}
								{
									dateOfBirth && <span className="dateOfBirth">({getFormItemLabel('born.short')} {DateUtils.formatDate(dateOfBirth)})</span>
								}
							</span>
							<span className="roles">
								{
									(party.get('roles') || EMPTY_LIST).map(role => {
										const relTypeId = role.get('roleRelTypeId');
										let roleTypeText;
										if (relTypeId === 'MEM' || relTypeId === 'ADM') {
											roleTypeText = getPhrase('childRoleRelType.' + relTypeId);
										} else {
											roleTypeText = role.get('roleType');
										}
										return roleTypeText;
									}).join(', ')
								}
							</span>
						</div>
						{
							altNames && !party.get('altNamesExpanded') &&
							<span className="link show" onMouseDown={() => toggleAltNamesExpanded(index)}>{getPhrase('showAltNames')}</span>
						}
						{
							altNames && party.get('altNamesExpanded') &&
							<div className="altNames">
								<div className="header">
									<span className="text">{getPhrase('altNames')}</span>
									<span className="link" onMouseDown={() => toggleAltNamesExpanded(index)}>{getPhrase('hide')}</span>
								</div>
								{
									altNames.map((altName, index) => {
										return (
											<div className="altName" key={index}>
												{altName}
											</div>
										);
									})
								}
							</div>
						}
					</Role>
				);
			})}
		</Roles>;}
}

const Roles = styled.div`
	display: table;
	min-width: 570px;
`;

const Role = styled.div`
	padding: 8px;
	color: ${props => props.theme.disabledTextColor};
	border-bottom: 1px solid #E8EFF1;
	.header {
		padding: 4px 0px;
		display: flex;
		.name {
			flex-grow: 1;
			font-size: 16px;
			font-weight: 400;
			.dateOfBirth {
				margin-left: 8px;
				font-size: 14px;
			}
		}
		.role {
			font-weight: 400;
			font-style: italic;
			min-width: 220px;
		}
	}

	.link {
		color: #306DA0;
		cursor: pointer;
		line-height: 24px;
		font-weight: 300;
		&.show {
			margin-top: 4px;
		}
		&:hover {
			text-decoration: underline;
		}
	}

	.altNames {
		margin-left: 32px;
		.text {
			line-height: 24px;
			font-weight: 400;
		}
		.link {
			margin-left: 16px;
		}
		.altName {
			font-weight: 300;
			line-height: 24px;
		}
	}
`;